export default __webpack_public_path__ + "static/media/promo_06.0129b013.jpg";